import { ProductionFolderPlanningFilterKeys } from '../production-folder/production-folder-planning-filter-keys';

/**
 * TypeScript twin of the backend `ProductionStepPlanningFilterKeys` constants
 * (Digiwall.GoliathDocuments.Planning, Domain.Shared). The planned entity is a `WorkOrderStepLine` of a
 * ProductionFolderDoc, so these carry every parent-document filter of the base ProductionFolder source
 * (reused verbatim) plus the step-line specific ones (StepName / Equipment / Worker). These strings are
 * the FE↔BE contract — a wrong key silently no-ops (the backend applier ignores unknown keys), so keep
 * both sides in sync.
 */
export const ProductionStepPlanningFilterKeys = {
  // Parent ProductionFolderDoc filters (reused from the base source).
  dayBook: ProductionFolderPlanningFilterKeys.dayBook,
  customer: ProductionFolderPlanningFilterKeys.customer,
  manufacturer: ProductionFolderPlanningFilterKeys.manufacturer,
  description: ProductionFolderPlanningFilterKeys.description,
  displayNumber: ProductionFolderPlanningFilterKeys.displayNumber,
  // Step-line specific filters.
  stepName: 'StepName',
  equipment: 'Equipment',
  worker: 'Worker',
} as const;

export type ProductionStepPlanningFilterKey =
  (typeof ProductionStepPlanningFilterKeys)[keyof typeof ProductionStepPlanningFilterKeys];

/** Dropdown (multi-select) filters — the only ones allowed to carry preset values. */
export const PRODUCTION_STEP_DROPDOWN_KEYS: ProductionStepPlanningFilterKey[] = [
  ProductionStepPlanningFilterKeys.dayBook,
  ProductionStepPlanningFilterKeys.customer,
  ProductionStepPlanningFilterKeys.manufacturer,
  ProductionStepPlanningFilterKeys.equipment,
  ProductionStepPlanningFilterKeys.worker,
];

/** Free-text filters — client-side substring only, never carry preset values. */
export const PRODUCTION_STEP_TEXT_KEYS: ProductionStepPlanningFilterKey[] = [
  ProductionStepPlanningFilterKeys.description,
  ProductionStepPlanningFilterKeys.displayNumber,
  ProductionStepPlanningFilterKeys.stepName,
];
